import { AxiosInstance } from 'axios'
import { useCallback } from 'react'

export function useInterceptorServiceWithUserToken(
  service: AxiosInstance,
  userToken: string,
) {
  const perform = useCallback(() => {
    const request = service.interceptors.request.use(async (config) => {
      const { Authorization } = config.headers
      if (Authorization) {
        return config
      }

      if (userToken) {
        const bearerToken = `Bearer ${userToken}`
        config.headers.set('Authorization', bearerToken)
      }

      return config
    })

    return () => {
      service.interceptors.request.eject(request)
    }
  }, [userToken])

  return {
    perform,
  }
}
